module.exports = require("@seddi/three/examples/jsm/loaders/GLTFLoader.js");